<script setup>
   import { ref, watch, reactive, inject } from 'vue'
   import { useRoute } from 'vue-router'
   import { modalHide } from '@/composables/bootstrap'

   const route = useRoute()

   const $storeCollections = inject('$storeCollections')

   const props = defineProps({
      action: {
         type: String,
         required: true
      },
      collection: {
         type: Object,
         required: true
      }
   })

   /**
      * Function: deleteCollection
      * @description The user confirmed the delete.
      * Send the delete request to the API.
   */
   const confirmationName = ref('')
   const deleteCollection = () => {
      if(! deleteIsValid.value) return

      $storeCollections.delete(parseInt(props.collection.id))
      modalHide('delete-collection')
      confirmationName.value = ''
   }

   const deleteIsValid = ref(false)
   watch(() => confirmationName.value, newData => {
      if(newData == props.collection.name) deleteIsValid.value = true
      else deleteIsValid.value = false
   })
</script>

<template>
   <!-- Delete Ginnel Modal -->
   <Modal v-if="action == 'delete-collection'" id="delete-collection" size="medium">
      <template #header>Delete Collection</template>
      <template #body>
         <div class="cg-column-content">
            <div>Are you sure you want to delete <strong class="text-warning">{{ collection.name }}?</strong></div>
            <div>
               <em class="text-danger">You will lose all associated Ginnels and their Files.</em> <br>
               <strong class="text-danger">This can't be undone.</strong>
            </div>

            <form @submit.prevent="deleteCollection()" class="cg-column-content">
               <div>
                  <div>
                     <label for="collection-name" class="form-label label-required">Please type <strong class="text-warning">{{ collection.name }}</strong> in the field to confirm.</label>
                     <input id="collection-name" type="text" class="form-control" :class="{ 'is-valid': deleteIsValid }" v-model="confirmationName" placeholder="Collection Name" required>
                  </div>

               </div>

               <div class="d-flex justify-content-end">
                  <DangerButton>
                     <template #label>Confirm Delete</template>
                  </DangerButton>
               </div>
            </form>
         </div>
      </template>
   </Modal>
</template>